/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axios_instance';
import {
  UserDesignationInterface,
  UserProfileDataInterface,
} from '../components/utils/interfaces';
import { BaseUrlGeneral } from '../utils';
import { UserDesignationObject, UserProfileDataObject } from '../utils/object';

const useGetProfileData = () => {
  const [userProfileData, setUserProfileData] =
    useState<UserProfileDataInterface>(UserProfileDataObject);
  const [userDesignationData, setUserDesignationData] =
    useState<UserDesignationInterface>(UserDesignationObject);
  const [userProfilePictureData, setUserProfilePictureData] = useState<any>('');
  const history = useNavigate();

  useEffect(() => {
    // const token = getToken();
    // if (token === null) {
    //   history('/signin');
    // }
    axiosInstance
      .get(BaseUrlGeneral + `/api/v1/profile/user-profiles/`)
      .then((response) => {
        setUserProfileData(response.data);
        setUserProfilePictureData(
          BaseUrlGeneral +
            '/api/v1/profile-picture/' +
            response.data['id'] +
            `?${Date.now()}`
        );
      })
      .catch((error) => {
        console.log(error);
      });

    axiosInstance
      .get(BaseUrlGeneral + `/api/v1/profile/user-profiles/designation`)
      .then((response) => {
        setUserDesignationData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return [
    userProfileData,
    setUserProfileData,
    userDesignationData,
    setUserDesignationData,
    userProfilePictureData,
    setUserProfilePictureData,
  ];
};

export default useGetProfileData;

export const useGetProfileDataByAdmin = (employeeId: any) => {
  const [userProfileData, setUserProfileData] =
    useState<UserProfileDataInterface>(UserProfileDataObject);
  const [userDesignationData, setUserDesignationData] =
    useState<UserDesignationInterface>(UserDesignationObject);
  const [userProfilePictureData, setUserProfilePictureData] = useState<any>('');

  useEffect(() => {
    axiosInstance
      .get(BaseUrlGeneral + `/api/v1/admin/user-profiles/` + employeeId)
      .then((response) => {
        setUserProfileData(response.data);
        setUserProfilePictureData(
          BaseUrlGeneral + '/api/v1/profile-picture/' + response.data['id']
        );
      })
      .catch((error) => {
        console.log(error);
      });

    axiosInstance
      .get(
        BaseUrlGeneral +
          `/api/v1/profile/admin/user-profiles/` +
          employeeId +
          `/designation`
      )
      .then((response) => {
        setUserDesignationData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return [
    userProfileData,
    setUserProfileData,
    userDesignationData,
    setUserDesignationData,
    userProfilePictureData,
    setUserProfilePictureData,
  ];
};
